<template>
    <div class="faqs">
        <div class="faqs__search" data-float-labels data-float-labels-class-prefix="form-field">
            <div class="row">
                <div class="col-12 col-lg-6">
                    <div class="form-field form-field--floated-label">
                        <input v-model="searchTerm" id="search" type="text"/>
                        <label for="search">Search</label>
                    </div>
                </div>
            </div>
        </div>
        <div class="faqs__body">
            <div class="faqs__list">
                <accordion-item v-for="item in filteredItems" :key="item.id" class="accordion-item--q-and-a">
                    <h3 slot="title">{{ item.title }}</h3>
                    <div slot="content" v-html="item.content" class="richtext"></div>
                </accordion-item>
                <div v-if="!filteredItems.length">
                    <slot name="noResults"></slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AccordionItem from './AccordionItem';
import { floatLabels } from '../../partials/_float-labels';

export default {
    data: () => ({
        searchTerm: '',
    }),
    props: {
        items: {
            type: Array,
            required: true,
            default: () => []
        }
    },
    computed: {
        filteredItems() {
            if(!this.searchTerm) return this.items;

            let filteredItems = this.items;

            if(this.searchTerm) {
                filteredItems = filteredItems.filter(i => {
                    if(!this.searchTerm) return;

                    return [i.title,i.answer].join(',').toLowerCase().includes(this.searchTerm.toLowerCase());
                });
            }

            return filteredItems;
        }
    },
    components: {
        AccordionItem
    },
    updated() {
        floatLabels();
    }
}
</script>